module.exports = __webpack_public_path__ + "img/定制化解决方案.0a60400b.svg";